module.exports = __webpack_public_path__ + "booking-src-icon.png?d4b20bb417e918a28614d0a29cabb997";